module.exports = __webpack_public_path__ + "static/media/superBlot-4.9ed398f6.png";